import React from "react";
import "./styles/FilterChips.css";

/**
 * The category filter used on Einblicke, FAQ, Termine and Downloads.
 * Those were four separate implementations with different padding,
 * gaps and active colours; this is one.
 *
 * `options` accepts plain strings or { value, label, color } objects.
 * The optional `color` renders Termine's coloured dot.
 *
 * <FilterChips
 *   options={categories}
 *   value={active}
 *   onChange={setActive}
 *   allLabel="Alle"
 * />
 */
export default function FilterChips({
  options = [],
  value,
  onChange,
  allLabel = "Alle",
  showAll = true,
  label = "Kategorien",
}) {
  const items = options.map((opt) =>
    typeof opt === "string"
      ? { value: opt, label: opt }
      : { value: opt.value ?? opt.name, label: opt.label ?? opt.name, color: opt.color }
  );

  const all = showAll ? [{ value: allLabel, label: allLabel }] : [];

  return (
    <div className="rs-chips" role="tablist" aria-label={label}>
      {[...all, ...items].map((item) => {
        const isActive = value === item.value;

        return (
          <button
            key={item.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`rs-chip ${isActive ? "is-active" : ""}`}
            style={item.color ? { "--rs-chip-dot": item.color } : undefined}
            onClick={() => onChange(item.value)}
          >
            {item.color && <span className="rs-chip__dot" aria-hidden="true" />}
            {item.label}
          </button>
        );
      })}
    </div>
  );
}